import { NodeData } from '../dataSourceTypes';

interface Validator {
  validate(node: NodeData, additionalData?: string): Validation | Promise<Validation>;
}

export abstract class SyncValidator implements Validator {
  public abstract validate(node: NodeData): Validation;
}

export abstract class AsyncValidator implements Validator {
  public abstract validate(node: NodeData): Promise<Validation>;
}

export class ValidatorManager {
  public static async validate(
    validators: Array<Validator>,
    node: NodeData,
    additionalData?: string
  ): Promise<ValidationResult> {
    let validation: Validation = null;
    let isValid = true;

    for (const validator of validators) {
      validation = await validator.validate(node, additionalData);
      isValid = validation === null ? true : false;

      if (!validation) {
        break;
      }
    }

    return { isValid, validation };
  }
}

export interface ValidationResult {
  isValid: boolean;
  validation: Validation;
}

export interface NodeDirectorState {
  input?: string | number;
  error?: ValidationErrors | null;
  rename?: boolean;
}

interface ValidationErrors {
  [key: string]: any;
}

export type Validation = ValidationErrors | null;

export enum ValidatorType {
  RENAME = 'rename',
  DELETE = 'delete',
  CREATE_NODE = 'create_node',
}
